<template>
  <div>
    <h1>Map</h1>
    
    <b-container>
      <!-- <div id="map" style="width:100%;height: 450px">

      </div> -->
      <l-map use-global-leaflet  style="width:100%;height: 450px" :zoom="zoom" :center="center" ref="map" @ready="onLeafletReady" :options="{attributionControl: false}">
        <l-tile-layer :url="url"></l-tile-layer>
        <l-control-layers/>
        <l-draw-toolbar position="topright"/>
        <l-feature-group ref="featureGroup"
                        @ready="onFeatureGroupReady($event)">
        </l-feature-group>
      </l-map>
    </b-container>

  </div>
</template>

<script>
// import "leaflet";

// import "leaflet/dist/leaflet.css";
// import "leaflet-draw/dist/leaflet.draw.css";
// import "leaflet-toolbar/dist/leaflet.toolbar.css";
// import "leaflet-draw/dist/leaflet.draw-src.js";
// import "leaflet-toolbar";
// import "leaflet-draw-toolbar/dist/leaflet.draw-toolbar.js";

export default {
  name: "Map",
  
  data() {
    return {
      /*patterns: [
        {
          offset: 12,
          repeat: 50,
          symbol: L.Symbol.arrowHead({
            pixelSize: 15,
            yawn: 45,
            fill:true,fillColor: "#00F",
            pathOptions: {fillOpacity: 1,
              weight: 0},
          }),
        },
      ],*/
      polyline: {
        latlngs: [
          [47.334852, -1.509485],
          [47.342596, -1.328731],
          [47.241487, -1.190568],
          [47.234787, -1.358337],
        ],
        color: "orange",
      },
      locations: [
        [32.1515, 42.44654],
        [32.1515, 42.574654],
        [32.1515, 42.504654],
        [32.1515, 42.584654],
        [32.1515, 42.584654],
        [32.1515, 42.16455],
        [32.1515, 42.264654],
        [32.1515, 42.264654],
        [32.1515, 42.264654],
        [32.1515, 42.264654]
      ],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 5,
      center: [47.31322, -1.319482],
      markerLatLng: [51.504, -0.159]
    }
  },
  mounted(){
  //   var map = L.map('map',{ drawControl: true }).setView([25, 25], 10);
  //    L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
  //        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
  //    }).addTo(map);
	//  L.marker([51.5, -0.09]).addTo(map)
  //   .bindPopup('A pretty CSS popup.<br> Easily customizable.')
  //   .openPopup();
  //    // FeatureGroup is to store editable layers
  //    var drawnItems = new L.FeatureGroup();
  //    console.log(drawnItems)
  //    map.addLayer(drawnItems);
  //    var drawControl = new L.Control.Draw({
  //        edit: {
  //            featureGroup: drawnItems
  //        }
  //    });
  //    map.addControl(drawControl);

    // var map = this.$refs.map.mapObject;
    // console.log(map)
    // var drawnItems = new L.FeatureGroup();
    //   map.addLayer(drawnItems);
    //   var drawControl = new L.Control.Draw({
    //      edit: {
    //          featureGroup: drawnItems
    //      }
    //  });
    //  map.addControl(drawControl);
  },
  methods:{
    // async onLeafletReady() {
    //         await this.$nextTick();
    //         this.$refs.map.mapObject.on(L.Draw.Event.CREATED, (e) => {
    //             const type = e.layerType;
    //             if (type === 'polygon') {
                   
    //             } 
    //             console.log(e.layer.getLatLngs())
    //         });
    //     },
    //     async onFeatureGroupReady(val) {
    //         await this.$nextTick();
    //         const drawControl = new L.Control.Draw(this.getDrawConfiguration(val));
    //         this.$refs.map.mapObject.addControl(drawControl);
    //     },
    //     getDrawConfiguration(editableLayers) {
    //         return {
    //             position: 'topright',
    //             draw: {
    //                 polygon: {
    //                     allowIntersection: false, // Restricts shapes to simple polygons
    //                     drawError: {
    //                         color: '#e1e100', // Color the shape will turn when intersects
    //                         message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
    //                     },
    //                     shapeOptions: {
    //                         color: '#97009c'
    //                     }
    //                 },
    //                 // disable toolbar item by setting it to false
    //                 polyline: false,
    //                 circle: false,
    //                 circleMarker: false,
    //                 rectangle: false,
    //                 marker: false,
    //             },
    //             edit: {
    //                 featureGroup: editableLayers,
    //                 remove: false
    //             }
    //         };
    //     },
  }
}
</script>

<style scoped>

</style>




